<template>
  <div id="top-header">
    <div class="header-left-decoration">
      <dv-decoration-8 class="decorationHeader" />
      <div class="timeWear">
        <div>{{ dateStrings }}</div>
        <div class="timeStrings">{{ timeStrings }}</div>
      </div>
    </div>
    <div class="header-center-decoration">
      <div class="center-title">{{ headerTitle }}</div>
      <dv-decoration-5 class="decorationCenter" />
    </div>
    <div class="header-right-decoration decorationRight">
      <div class="weather_box">
        <div class="wea_list" v-for="(item, index) in weather" :key="index">
          <div class="wea_box">
            <!-- 当天日期 -->
            <!-- <div>{{ item.date }}</div> -->
            <!-- <div class="week_box">{{item.week}}</div> -->
            <!-- 天气情况 -->
            <div class="fontStyle">
              <i
                :class="`iconfontStyle iconfont ${
                  item.dayweather == '多云'
                    ? 'icon-duoyun'
                    : '' || item.dayweather == '雷阵雨'
                    ? 'icon-leizhenyu1'
                    : '' || item.dayweather == '晴'
                    ? 'icon-qing'
                    : '' || item.dayweather == '小雨'
                    ? 'icon-xiaoyu'
                    : '' || item.dayweather == '阴天'
                    ? 'icon-yintian'
                    : '' || item.dayweather == '阵雨'
                    ? 'icon-zhenyu'
                    : ''
                }`"
              ></i>
              <div>{{ item.dayweather }}</div>
            </div>
            <!-- <div class="nigtw_box">{{item.nightweather}}</div> -->
            <!-- 温度 -->
            <div style="font-size: 22px">
              {{ item.daytemp }}~{{ item.nighttemp }}°C
            </div>
            <!-- <div class="wind_box">{{item.daywind}}~{{item.nightwind}}</div> -->
            <!-- <div class="power_box">{{item.daypower}}~{{item.nightpower}}</div> -->
            <!-- <div>{{item.daytemp_float}}~{{item.nighttemp_float}}</div> -->
          </div>
        </div>
      </div>
      <dv-decoration-8 class="decorationHeader decora" :reverse="true" />
    </div>
  </div>
</template>

<script>
import testHeaderTitle from '../../assets/json/headerTitle.json'
export default {
  name: 'headerTitle',
  data() {
    return {
      headerTitle: '',
      city: '万载县',
      dateStrings: '',
      timeStrings: '',
      weather: []
    }
  },
  created() {
    // 初始化天气
    this.getWeather()
    // 初始化时间
    this.updateTime()
    this.headerTitle = testHeaderTitle.headerTitle
  },
  methods: {
    // 天气数据获取
    getWeather: function () {
      let that = this
      this.$axios({
        url: 'https://restapi.amap.com/v3/weather/weatherInfo',
        method: 'GET',
        params: {
          key: 'f05572c6bb854256b7f060d821e7dcaa',
          city: this.city,
          extensions: 'all',
          output: 'JSON'
        }
      })
        .then(function (response) {
          that.weather = response.data.forecasts[0].casts.slice(0, 1)
        })
        .catch(function (error) {
          alert('请求失败 ' + error)
        })
    },
    changeCity: function (city) {
      this.city = city
      this.getWeather()
    },
    // 获取当前时间
    updateTime() {
      let date = new Date()

      let year = date.getFullYear()
      let month = (date.getMonth() + 1).toString().padStart(2, '0')
      let day = date.getDate().toString().padStart(2, '0')

      this.dateStrings = `${year}年${month}月${day}日`
      let timeString = date.toTimeString().split(' ')[0]
      this.timeStrings = timeString

      setTimeout(this.updateTime, 1000)
    }
  }
}
</script>

<style lang="less">
#top-header {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  box-sizing: border-box;

  .header-center-decoration {
    width: 25%;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
  }

  .header-left-decoration,
  .header-right-decoration {
    width: 35%;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    .decorationHeader {
      width: 40%;
      height: 50px;
    }
    .decora {
      margin-left: 3%;
    }
    .timeWear {
      display: flex;
      flex-direction: row;
      font-weight: 700;
      font-size: 28px;
      margin-left: 3%;
      .timeStrings {
        font-size: 30px;
        margin-left: 10px;
      }
    }
    .weather_box {
      display: flex;
      flex-direction: row;
      align-items: center;
      .wea_list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        margin-right: 10%;
        box-sizing: border-box;
        .wea_box {
          width: 250px;
          padding: 1%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-around;
          font-weight: 800;
          font-size: 20px;
          .fontStyle {
            display: flex;
            flex-direction: row;
            align-items: center;
            .iconfontStyle {
              margin-right: 10px;
              margin-top: -10px;
              font-weight: 700;
              font-size: 40px;
            }
          }
        }
      }
    }
  }
  .decorationRight {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .center-title {
    font-size: 30px;
    font-weight: bold;
  }
}
</style>
